export const USER_ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  VIEWER: 'VIEWER'
};

export const PERMISSIONS = {
  ABSENCES: {
    VIEW: 'absences:view',
    CREATE: 'absences:create',
    EDIT: 'absences:edit',
    DELETE: 'absences:delete'
  },
  ASTREINTES: {
    VIEW: 'astreintes:view',
    CREATE: 'astreintes:create',
    EDIT: 'astreintes:edit',
    DELETE: 'astreintes:delete'
  },
  USERS: {
    VIEW: 'users:view',
    CREATE: 'users:create',
    EDIT: 'users:edit',
    DELETE: 'users:delete'
  }
};

export const ROLE_PERMISSIONS = {
  [USER_ROLES.SUPER_ADMIN]: Object.values(PERMISSIONS).flatMap(p => Object.values(p)),
  [USER_ROLES.ADMIN]: [
    ...Object.values(PERMISSIONS.ABSENCES),
    ...Object.values(PERMISSIONS.ASTREINTES),
    PERMISSIONS.USERS.VIEW
  ],
  [USER_ROLES.VIEWER]: [
    PERMISSIONS.ABSENCES.VIEW,
    PERMISSIONS.ASTREINTES.VIEW
  ]
}; 